import { f0FormField } from '@factorialco/f0-react'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'
import { EmployeeSelectorV2 } from 'modules/employees/components/EmployeeSelectorV2'

export const createScopeStepSchema = () =>
  z.object({
    scopeEmployeeIds: f0FormField(z.array(z.string()), {
      fieldType: 'custom',
      label: i18n.t('planning.period_wizard.scope.participants_label'),
      render: ({ value, onChange }) => (
        <EmployeeSelectorV2
          multiple
          value={value ?? []}
          onChange={(state) => {
            if (state.type === 'manual') {
              onChange(state.ids)
            }
          }}
          label={i18n.t('planning.period_wizard.scope.participants_label')}
          options={{ disableSelectAll: true }}
        />
      ),
    }),
  })
